<template>
  <v-dialog
    :value="visible"
    :max-width="maxWidth"
    persistent
    @input="onDialogInput">
    <v-card>
      <div
        class="d-flex align-center justify-space-between primary white--text fill-width px-6 mb-6"
        style="height: 60px;">
        <div class="d-flex align-center">
          <span class="white--text font-weight-bold invoice-parameter-text-xl">
            {{ title }}
          </span>
        </div>
        <v-icon
          size="26"
          color="white"
          @keydown.shift.space.stop.prevent="onCancel"
          @keydown.ctrl.enter.stop.prevent="onSave"
          @click="onCancel">
          mdi mdi-close
        </v-icon>
      </div>

      <v-card-text>
        <v-textarea
          ref="textarea"
          v-model="localValue"
          auto-grow
          row-height="24"
          rows="4"
          outlined
          :rules="rules"
          @keydown.shift.space.stop.prevent="onCancel"
          @keydown.ctrl.enter.stop.prevent="onSave"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="btn-component primary--text"
          text
          color="primary"
          @keydown.shift.space.stop.prevent="onCancel"
          @click="onCancel">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          class="btn-component white--text"
          color="primary"
          @keydown.shift.space.stop.prevent="onCancel"
          @click="onSave">
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AdmissionMapFieldDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    maxWidth: {
      type: [String, Number],
      default: 600,
    },
  },

  data: () => ({ localValue: '' }),

  watch: {
    visible: {
      handler(isVisible) {
        if (isVisible) {
          this.localValue = this.normalizeValue(this.value);
          this.$nextTick(() => {
            this.resetValidation();
            this.focusTextarea();
          });
          return;
        }

        this.localValue = '';
      },
      immediate: true,
    },
    value(nextValue) {
      if (!this.visible) return;
      this.localValue = this.normalizeValue(nextValue);
    },
  },

  methods: {
    normalizeValue(value) {
      if (value === null || value === undefined) return '';
      return String(value);
    },
    getTextareaRef() {
      const ref = this.$refs.textarea;
      return Array.isArray(ref) ? ref[0] : ref;
    },
    focusTextarea() {
      const textarea = this.getTextareaRef();
      if (!textarea || typeof textarea.focus !== 'function') return;
      setTimeout(() => {
        textarea.focus();
      }, 300);
    },
    validate() {
      const textarea = this.getTextareaRef();
      if (!textarea || typeof textarea.validate !== 'function') return true;
      return Boolean(textarea.validate(true));
    },
    resetValidation() {
      const textarea = this.getTextareaRef();
      if (!textarea || typeof textarea.resetValidation !== 'function') return;
      textarea.resetValidation();
    },
    onDialogInput(value) {
      if (!value) {
        this.onCancel();
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSave() {
      if (this.rules.length > 0 && !this.validate()) return;
      this.$emit('save', this.localValue);
    },
  },
};
</script>
